import Link from 'next/link';
import { useParams } from 'next/navigation';
import { CommunityStatuses } from 'types/communityStatuses';
import { routes } from 'utils/routerHelpers';

import React from 'react';

import { Badge } from '@thinkific/chalk/react-components';

import { useCommunityContext } from 'components/CommunityContext';

export const CommunityStatusBadge = () => {
  const { communityId } = useParams();
  const { community } = useCommunityContext();
  if (community.status !== CommunityStatuses.DRAFT) return null;
  return (
    <Link href={routes.publishCommunity(communityId as string)}>
      <Badge emphasis="medium" label={community.status} roundness="full" variant="neutral" />
    </Link>
  );
};

export default CommunityStatusBadge;
